import { Endpoints } from '@/network';
import { apiClient } from '@/services/apiClients';
import { IResponse } from '@/utils/interfaces';
import {
  IOnboarding,
  ISaveOnboardingAnswerPayload,
} from '@/utils/interfaces/Onboarding';

export const getOnboarding = async (): Promise<IResponse<IOnboarding>> => {
  const response = await apiClient.get(Endpoints.getOnboarding);

  return response?.data;
};

export const saveOnboardingAnswer = async (
  data: Partial<ISaveOnboardingAnswerPayload>,
): Promise<IResponse<IOnboarding>> => {
  const response = await apiClient.post(Endpoints.saveOnboardingAnswer, data);

  return response?.data;
};
